import {
  SET_SELECTED_EXPERIENCE,
  CLEAR_SELECTED_EXPERIENCE,
  SET_EXPERIENCE_COMMENT,
  SET_OPTION_FEEDBACK,
  SET_SELECTED_LOCATION,
  CLEAR_SELECTED_LOCATION
} from '../actions/experienceAction';

const initialState = {
  selectedExperience: {},
  isExperienceSelected: false,
  comments: {},
  feedback: {}, 
  selectedLocation: '',
  isLocationSelected: false
};

const experienceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_EXPERIENCE:
      return {
        ...state,
        selectedExperience: {
          ...state.selectedExperience,
          [action.payload.option]: action.payload.experience,
        },
        isExperienceSelected: true,
      };

    case CLEAR_SELECTED_EXPERIENCE:
      return {
        ...state,
        selectedExperience: {},
        isExperienceSelected: false,
        feedback: {},
      };

    case SET_EXPERIENCE_COMMENT:
      return {
        ...state,
        comments: {
          ...state.comments,
          [action.payload.option]: action.payload.comment,
        },
      };

    case SET_OPTION_FEEDBACK:
      return {
        ...state,
        feedback: {
          ...state.feedback,
          [action.payload.option]: {
            rating: action.payload.experience,
            comment: action.payload.comment,
          },
        },
        isExperienceSelected: true,
      };

      case SET_SELECTED_LOCATION:
      return {
        ...state,
        selectedLocation: action.payload,
        isLocationSelected: true, 
      };

    case CLEAR_SELECTED_LOCATION:
      return {
        ...state,
        selectedLocation: "",
        isLocationSelected: false, 
      };

    default:
      return state;
  }
};

export default experienceReducer;
